<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Name"
                  v-model="formSchema.name"
                  :rules="[v => !!v || 'Field is required']"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  label="Role"
                  item-text="label"
                  item-value="value"
                  v-model="formSchema.role_id"
                  :items="roleList"
                  :rules="[v => !!v || 'Role is required']"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Email"
                  v-model="formSchema.email"
                  :rules="email_rules"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Password"
                  v-model="formSchema.password"
                  :rules="[v => !!v || 'Field is required']"
                  required
                ></v-text-field>
              </v-flex>
                <v-flex xs12 sm6 md6>
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
          <v-btn color="blue" @click.native="close(0)">
            <v-icon>close</v-icon>Close
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    roleList: [],
    isActiveVal: 1,
    email_rules: [
      v => !!v || "Field is required",
      v =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    ]

    /*formSchema: {
				id: "",
				name: "",
				code: "",
				address: ""
			},*/
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit User" : "Add New User";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    let root = this;
    commonService.getAllData("get-role-list").then(res => {
      root.roleList = res.roleList;
    });
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService.updateFormData(this.formSchema, "user").then(res => {
              this.close(res);
          });
        } else {
          commonService.insertFormData(this.formSchema, "user").then(res => {
              this.close(res);
          });
        }
      }
    },

    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(res) {      
      if(res.status == 1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitCloseModal", res);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/user/insertForm.vue